import axios from "axios";
import { API_BASE_URL, API_PASSWORD } from "./apiConfig"; // 👈 استدعاء

// إعداد Axios
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const getClients = () => {
  const token = localStorage.getItem("authToken");
  return api.get(`clients?api_password=${API_PASSWORD}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};

export const getAllUsersTenants = () => {
  const token = localStorage.getItem("authToken");
  return api.get(
    `users/tenants?api_password=${API_PASSWORD}`,
    {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    }
  );
};

export const createClientVersion = (payload, isFormData = false) => {
  const token = localStorage.getItem("authToken");
  const url = `create/client/version?api_password=${API_PASSWORD}`;

  const headers = {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(isFormData ? { "Content-Type": "multipart/form-data" } : { "Content-Type": "application/json" }),
  };

  // إذا كان FormData، أرسل مباشرة؛ وإلا أرسل JSON
  return api.post(url, payload, { headers });
};

// New: تفعيل الحساب يدويًا عبر API (GET)
export const activateAccountManually = (userId) => {
  const token = localStorage.getItem("authToken");
  const encodedId = encodeURIComponent(userId);
  const url = `active/account/manually/${encodedId}?api_password=${API_PASSWORD}`;
  return api.get(url, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};


export const changeTenantStatus = (tenantId) => {
  const token = localStorage.getItem("authToken");
  const url = `change/tenant/status`;

  return api.post(
    `${url}?api_password=${API_PASSWORD}`,
    { tenant_id: tenantId },
    {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    }
  );
};

export const editTenantDate = (payload) => {
  const token = localStorage.getItem("authToken");
  const url = `edite/tenant/date?api_password=${API_PASSWORD}`;

  const formData = new FormData();
  Object.keys(payload).forEach((key) => {
    formData.append(key, payload[key]);
  });

  return api.post(url, formData, {
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getUserProfile = () => {
  const token = localStorage.getItem("authToken");
  const url = `profile?api_password=${API_PASSWORD}`;
  return api.get(url, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};

export const activateDemoPlan = (payload) => {
  console.log("Activating demo plan with payload:", payload);
  const token = localStorage.getItem("authToken");

  const url = `active/demo/to/tenant?api_password=${API_PASSWORD}`;

  const formData = new FormData();
  Object.keys(payload).forEach((key) => {
    formData.append(key, payload[key]);
  });

  return api.post(url, formData, {
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      "Content-Type": "multipart/form-data",
    },
  });
};



